import { SkeletonThemeProps } from 'react-loading-skeleton';

import { primarySkeletonTheme, secondarySkeletonTheme } from './skeleton-theme';
import { SkeletonThemeType } from './types';

export const buildSkeletonTheme: (
  skeletonTheme?: SkeletonThemeType
) => SkeletonThemeProps = skeletonTheme =>
  skeletonTheme === SkeletonThemeType.SECONDARY ? secondarySkeletonTheme : primarySkeletonTheme;
